module.exports = __webpack_public_path__ + "static/img/Spotify_logo.22800d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Spotify_logo.svg
// module id = +P6q
// module chunks = 1